import { z } from 'zod'

import { PickerItems } from '../../types/picker'

export const TransactionsStateSchema = z.object({
  sources: z.custom<PickerItems | undefined>(),
  types: z.custom<PickerItems | undefined>(),
})
